const { GraphQLClient } = require('graphql-request');

export const DECENTRALAND_END_POINT =
  'https://api.thegraph.com/subgraphs/name/decentraland/marketplace';

export const decentralandClient = new GraphQLClient(DECENTRALAND_END_POINT);
